import { render, staticRenderFns } from "./VisibleSignature.vue?vue&type=template&id=5fa2f63f&scoped=true"
import script from "./VisibleSignature.vue?vue&type=script&lang=js"
export * from "./VisibleSignature.vue?vue&type=script&lang=js"
import style0 from "./VisibleSignature.vue?vue&type=style&index=0&id=5fa2f63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2f63f",
  null
  
)

export default component.exports